<ng-container *ngIf="masqueradeMode">
  <div class="user-masquerade-mode-wrapper">
    <div class="user-masquerade-mode">
      <div class="masquerade-info">
        <vng-icon name="visibility" [outline]="false" class="masquerade-icon"></vng-icon>
        <span class="masquerade-text">
          Viewing as: <strong>{{ masqueradeUserName }}</strong>
          <span class="company-name" *ngIf="masqueradeCompanyName">({{ masqueradeCompanyName }})</span>
        </span>
        <span class="remaining-time" [class.warning]="masqueradeRemainingTime <= 10"
          *ngIf="masqueradeRemainingTime > 0">
          {{ masqueradeRemainingTime }}m remaining
        </span>
      </div>
      <button vng-button variant="secondary" (click)="endMasquerade()" class="end-masquerade-btn">
        <vng-icon name="exit_to_app" [outline]="false" style="color: #fff"></vng-icon>
        Exit Masquerade
      </button>
    </div>
  </div>
</ng-container>
<div *ngIf="presentExtensionPrompt">
  <app-pin-to-browser></app-pin-to-browser>
</div>
<div class="app" [dir]="options.dir" [ngClass]="{
    'app-dark': options.dark,
    boxed: options.boxed,
    'collapsed-sidebar': options.collapsed,
    'side-panel-opened': sidePanelOpened,
    'side-panel-closed': !sidePanelOpened
  }">
  <!-- fix(shell): replaces vng-sidenav + the separately-floating .mini-sidebar
       it used to wrap with a single ALWAYS-fixed `<aside>` (flymsg-roleplay's
       layout.component.html/sidebar.component.html pattern — no sidenav
       container at all). Both the collapsed rail and the expanded app-menu
       panel stay permanently mounted inside it (never *ngIf'd away) so:
       (a) app-menu's ngOnInit data fetches / store subscriptions only ever
       run once, not on every collapse/expand toggle, and (b) e2e specs that
       reach into app-menu's DOM while the sidenav is collapsed (e.g.
       extension-settings-unsaved-changes.spec.ts's `img.logo` dispatchEvent)
       keep finding an attached element. Only ONE of the two is ever visible
       at a time via the `.is-hidden` (display:none) class below — see
       admin-layout.component.scss. -->
  <aside class="app-sidenav" [class.app-sidenav--collapsed]="!sidePanelOpened"
    [class.app-sidenav--expanded]="sidePanelOpened">
    <div class="mini-sidebar" [class.is-hidden]="sidePanelOpened">
      <!-- fix(shell): click handler moved from the icon glyph onto this
           wrapping circle so the whole 42px hit target opens the sidemenu,
           not just the icon's own (much smaller) glyph box — matching the
           close-icon-wrapper treatment in menu.component.html. -->
      <div class="menu-toggle sidemenu-item" (click)="toggleSidePanel()">
        <vng-icon name="menu" [outline]="false" style="color: #fff"></vng-icon>
      </div>

      <div class="sidemenu-item cursor-point">
        <img src="../../../assets/images/FM_logo.png" alt="logo" (click)="goToDashboard()" />
      </div>
      <div class="sidemenu-item dp-wrapper" (click)="goToProfile()" vngTooltip="Profile" vngTooltipPosition="right">
        <vng-icon name="person" [outline]="false" *ngIf="!avatarSrc || avatarFailed"></vng-icon>
        <img *ngIf="avatarSrc && !avatarFailed" [src]="avatarSrc" [alt]="user.first_name" (error)="avatarFailed = true" />
      </div>

      <div class="links-wrapper">
        <div class="sidemenu-link" routerLink="/flyboard" routerLinkActive="active" vngTooltip="FlyBoard"
          vngTooltipPosition="right">
          <a>
            <vng-icon name="dashboard" [outline]="false" class="sidemenu-icon"></vng-icon>
          </a>
        </div>

        <div class="sidemenu-link" (click)="openMenu('/shortcuts'); goToViewAllPage('flycuts')"
          [ngClass]="{ active: currentRoute.includes('shortcuts') }" vngTooltip="FlyCuts" vngTooltipPosition="right">
          <a>
            <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M6.75 17H11.25C15 17 16.5 15.5 16.5 11.75V7.25C16.5 3.5 15 2 11.25 2H6.75C3 2 1.5 3.5 1.5 7.25V11.75C1.5 15.5 3 17 6.75 17Z"
                stroke="#FFF" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M13.1258 13.3101H11.7383" stroke="#FFF" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M9.7275 13.3101H4.875" stroke="#FFF" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M13.1241 10.4902H8.97656" stroke="#FFF" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M6.9525 10.4902H4.875" stroke="#292D32" stroke-width="1.5" stroke-linecap="round"
                stroke-linejoin="round" />
            </svg>
          </a>
        </div>
        <div class="sidemenu-link" (click)="openMenu('/flyplates'); goToViewAllPage('flyplates')"
          [ngClass]="{ active: currentRoute.includes('flyplates') }" vngTooltip="FlyPlates" vngTooltipPosition="right">
          <a>
            <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M6 9.6499H11.25" stroke="#FFF" stroke-miterlimit="10" stroke-linecap="round"
                stroke-linejoin="round" />
              <path d="M6 12.6499H9.285" stroke="#FFF" stroke-miterlimit="10" stroke-linecap="round"
                stroke-linejoin="round" />
              <path d="M7.5 5H10.5C12 5 12 4.25 12 3.5C12 2 11.25 2 10.5 2H7.5C6.75 2 6 2 6 3.5C6 5 6.75 5 7.5 5Z"
                stroke="#FFF" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
              <path
                d="M12 3.51514C14.4975 3.65014 15.75 4.57264 15.75 8.00014V12.5001C15.75 15.5001 15 17.0001 11.25 17.0001H6.75C3 17.0001 2.25 15.5001 2.25 12.5001V8.00014C2.25 4.58014 3.5025 3.65014 6 3.51514"
                stroke="#FFF" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </a>
        </div>
        <div class="sidemenu-link" (click)="openMenu('/flyshare'); goToViewAllPage('flyshare')"
          [ngClass]="{ active: currentRoute.includes('flyshare') }" vngTooltip="FlyShare" vngTooltipPosition="right">
          <a>
            <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12.7207 5.12744C14.2207 6.16994 15.2557 7.82744 15.4657 9.73994" stroke="#FFF"
                stroke-linecap="round" stroke-linejoin="round" />
              <path d="M2.61719 9.77754C2.81219 7.87254 3.83219 6.21504 5.31719 5.16504" stroke="#FFF"
                stroke-linecap="round" stroke-linejoin="round" />
              <path
                d="M6.14258 16.2051C7.01258 16.6476 8.00258 16.8951 9.04508 16.8951C10.0501 16.8951 10.9951 16.6701 11.8426 16.2576"
                stroke="#FFF" stroke-linecap="round" stroke-linejoin="round" />
              <path
                d="M9.04594 6.27498C10.1975 6.27498 11.1309 5.34149 11.1309 4.18998C11.1309 3.03847 10.1975 2.10498 9.04594 2.10498C7.89442 2.10498 6.96094 3.03847 6.96094 4.18998C6.96094 5.34149 7.89442 6.27498 9.04594 6.27498Z"
                stroke="#FFF" stroke-linecap="round" stroke-linejoin="round" />
              <path
                d="M3.62211 15.44C4.77362 15.44 5.70711 14.5065 5.70711 13.355C5.70711 12.2035 4.77362 11.27 3.62211 11.27C2.4706 11.27 1.53711 12.2035 1.53711 13.355C1.53711 14.5065 2.4706 15.44 3.62211 15.44Z"
                stroke="#FFF" stroke-linecap="round" stroke-linejoin="round" />
              <path
                d="M14.378 15.44C15.5295 15.44 16.463 14.5065 16.463 13.355C16.463 12.2035 15.5295 11.27 14.378 11.27C13.2265 11.27 12.293 12.2035 12.293 13.355C12.293 14.5065 13.2265 15.44 14.378 15.44Z"
                stroke="#FFF" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </a>
        </div>

        <div *ngIf="showRoleplay" class="sidemenu-link" routerLinkActive="active" (click)="openRolePlay()"
          vngTooltip="RolePlay" vngTooltipPosition="right">
          <a>
            <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M14.1667 9.99984C16.4678 9.99984 18.3333 8.13435 18.3333 5.83317C18.3333 3.53199 16.4678 1.6665 14.1667 1.6665C11.8655 1.6665 10 3.53199 10 5.83317C10 6.4997 10.1565 7.12969 10.4347 7.68837C10.5087 7.83684 10.5333 8.00653 10.4905 8.16676L10.2423 9.09425C10.1346 9.49692 10.5029 9.86525 10.9056 9.7575L11.8331 9.50934C11.9933 9.4665 12.163 9.49109 12.3115 9.56509C12.8702 9.84334 13.5002 9.99984 14.1667 9.99984Z"
                stroke="white" stroke-width="1.5" />
              <path
                d="M2.29306 6.60459C2.27456 6.25991 1.98014 5.99549 1.63546 6.01399C1.29078 6.03249 1.02636 6.32691 1.04486 6.67159L2.29306 6.60459ZM3.09793 3.40992C2.86022 3.6602 2.87039 4.05579 3.12067 4.29351C3.37094 4.53123 3.76653 4.52105 4.00426 4.27078L3.09793 3.40992ZM8.05327 17.3434C8.34552 17.5271 8.73135 17.4391 8.91502 17.1468C9.09868 16.8546 9.0106 16.4687 8.71835 16.2851L8.05327 17.3434ZM11.7607 17.5485C11.4228 17.4777 11.0916 17.6943 11.0208 18.0321C10.9501 18.37 11.1666 18.7012 11.5045 18.772L11.7607 17.5485ZM12.2037 13.7862L12.5832 13.3866L11.6768 12.5258L11.2973 12.9254L12.2037 13.7862ZM13.8321 13.2184L15.4242 14.1348L16.0478 13.0515L14.4557 12.1351L13.8321 13.2184ZM15.7314 16.0347L14.5477 17.2811L15.454 18.1419L16.6378 16.8956L15.7314 16.0347ZM6.13252 14.1321C2.90241 10.7313 2.36059 7.86278 2.29306 6.60459L1.04486 6.67159C1.12757 8.21261 1.78188 11.3667 5.22619 14.9929L6.13252 14.1321ZM7.27863 8.60114L7.51764 8.34948L6.61133 7.48864L6.37231 7.74028L7.27863 8.60114ZM7.70542 5.21658L6.65459 3.73034L5.63393 4.45198L6.68476 5.93821L7.70542 5.21658ZM6.82548 8.1707C6.37231 7.74028 6.37173 7.74089 6.37115 7.74149C6.37096 7.74171 6.37038 7.74233 6.36998 7.74274C6.36918 7.7436 6.36838 7.74445 6.36756 7.74534C6.36592 7.7471 6.36422 7.74894 6.36248 7.75087C6.35898 7.75471 6.35527 7.75887 6.35137 7.76335C6.34358 7.77232 6.33501 7.78257 6.32585 7.79414C6.30753 7.81729 6.28681 7.84574 6.26507 7.87971C6.22148 7.94784 6.17419 8.03757 6.13416 8.15009C6.05273 8.37889 6.00837 8.68189 6.06381 9.06031C6.17273 9.80373 6.65987 10.8035 7.93266 12.1435L8.83902 11.2826C7.64927 10.0301 7.35623 9.25864 7.3006 8.87906C7.27378 8.69598 7.30103 8.59948 7.31182 8.56915C7.31788 8.55215 7.32184 8.54739 7.31797 8.55348C7.31608 8.55639 7.31233 8.56189 7.30603 8.56989C7.30288 8.57381 7.29908 8.57848 7.29455 8.58364C7.29228 8.58631 7.28983 8.58906 7.28718 8.59198C7.28586 8.5934 7.28448 8.59489 7.28306 8.59639C7.28235 8.59723 7.28163 8.59798 7.28088 8.59873C7.28052 8.59914 7.27995 8.59973 7.27977 8.59998C7.2792 8.60056 7.27863 8.60114 6.82548 8.1707ZM7.93266 12.1435C9.20168 13.4796 10.1602 14.0048 10.8914 14.1236C11.2666 14.1845 11.5703 14.1358 11.8003 14.0451C11.9128 14.0008 12.0018 13.9487 12.0685 13.9014C12.1018 13.8777 12.1295 13.8553 12.1519 13.8357C12.1631 13.8259 12.173 13.8167 12.1816 13.8084C12.1859 13.8043 12.1898 13.8003 12.1935 13.7966C12.1953 13.7948 12.1972 13.793 12.1988 13.7912C12.1997 13.7904 12.2005 13.7896 12.2013 13.7887C12.2017 13.7883 12.2023 13.7876 12.2025 13.7875C12.2031 13.7868 12.2037 13.7862 11.7505 13.3558C11.2973 12.9254 11.2979 12.9248 11.2984 12.9242C11.2987 12.924 11.2992 12.9234 11.2996 12.923C11.3004 12.9222 11.3011 12.9215 11.3018 12.9207C11.3033 12.9192 11.3047 12.9177 11.3061 12.9163C11.3089 12.9136 11.3115 12.9109 11.314 12.9085C11.3191 12.9036 11.3236 12.8995 11.3276 12.896C11.3356 12.889 11.3415 12.8845 11.3454 12.8818C11.3531 12.8762 11.3524 12.8781 11.3417 12.8823C11.3256 12.8886 11.2499 12.9154 11.0918 12.8897C10.7563 12.8352 10.0324 12.5391 8.83902 11.2826L7.93266 12.1435ZM6.65459 3.73034C5.80993 2.53569 4.11975 2.33414 3.09793 3.40992L4.00426 4.27078C4.43995 3.81207 5.20698 3.8481 5.63393 4.45198L6.65459 3.73034ZM14.5477 17.2811C14.3151 17.5259 14.0718 17.6571 13.8353 17.6804L13.9582 18.9244C14.5807 18.8629 15.0845 18.5309 15.454 18.1419L14.5477 17.2811ZM7.51764 8.34948C8.32396 7.5006 8.38102 6.17213 7.70542 5.21658L6.68476 5.93821C7.03655 6.43577 6.9826 7.09775 6.61133 7.48864L7.51764 8.34948ZM15.4242 14.1348C16.1083 14.5286 16.2421 15.4971 15.7314 16.0347L16.6378 16.8956C17.7253 15.7507 17.4085 13.8347 16.0478 13.0515L15.4242 14.1348ZM12.5832 13.3866C12.9044 13.0485 13.4048 12.9725 13.8321 13.2184L14.4557 12.1351C13.5403 11.6081 12.405 11.7592 11.6768 12.5258L12.5832 13.3866ZM8.71835 16.2851C7.89857 15.7699 7.02609 15.0728 6.13252 14.1321L5.22619 14.9929C6.18788 16.0054 7.14066 16.7699 8.05327 17.3434L8.71835 16.2851ZM13.8353 17.6804C13.3799 17.7254 12.6592 17.7366 11.7607 17.5485L11.5045 18.772C12.5449 18.9898 13.395 18.98 13.9582 18.9244L13.8353 17.6804Z"
                fill="white" />
            </svg>
          </a>
        </div>

        <div class="sidemenu-link" routerLinkActive="active" (click)="openlearning()" vngTooltip="FlyLearning"
          vngTooltipPosition="right">
          <a>
            <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M16.5 13.0548V4.00228C16.5 3.10228 15.765 2.43478 14.8725 2.50978H14.8275C13.2525 2.64478 10.86 3.44728 9.525 4.28728L9.3975 4.36978C9.18 4.50478 8.82 4.50478 8.6025 4.36978L8.415 4.25728C7.08 3.42478 4.695 2.62978 3.12 2.50228C2.2275 2.42728 1.5 3.10228 1.5 3.99478V13.0548C1.5 13.7748 2.085 14.4498 2.805 14.5398L3.0225 14.5698C4.65 14.7873 7.1625 15.6123 8.6025 16.3998L8.6325 16.4148C8.835 16.5273 9.1575 16.5273 9.3525 16.4148C10.7925 15.6198 13.3125 14.7873 14.9475 14.5698L15.195 14.5398C15.915 14.4498 16.5 13.7748 16.5 13.0548Z"
                stroke="#FFF" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M9 4.61768V15.8677" stroke="#FFF" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M5.8125 6.86768H4.125" stroke="#FFF" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M6.375 9.11768H4.125" stroke="#FFF" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </a>
        </div>

        <div *ngIf="showAdminSection" class="sidemenu-link"
          (click)="openMenu('/settings'); goToViewAllPage('settings')"
          [ngClass]="{ active: currentRoute.includes('settings') }" vngTooltip="Administration"
          vngTooltipPosition="right">
          <a>
            <svg-icon-sprite class="account-center" width="21px" height="21px" viewBox="0 0 80 80" src="icon-route-away"
              style="display: inline; vertical-align: middle">
            </svg-icon-sprite>
          </a>
        </div>
      </div>

      <div class="buttons-wrapper">
        <div class="sidemenu-btn" (click)="toggleSidePanel()" *ngIf="userPlan === 'freemium'">
          <vng-icon name="star_border" [outline]="false"></vng-icon>
        </div>

        <div class="sidemenu-btn">
          <div class="sidemenu_more_btn_div" (click)="toggleSidePanel()" style="position: relative">
            <vng-icon name="more_horiz" [outline]="false"></vng-icon>
          </div>
        </div>
      </div>
    </div>
    <div class="sidebar-panel" id="sidebar-panel" [class.is-hidden]="!sidePanelOpened">
      <app-menu [direction]="options.dir" (closeSideNav)="toggleSidePanel()"></app-menu>
    </div>
  </aside>

  <!-- fix(shell): mobile/narrow-viewport ("over" mode, isOver()) equivalent
       of Material's drawer backdrop — the expanded panel overlays content
       instead of pushing it (see .app-content--pushed in
       admin-layout.component.scss), so a click-anywhere-to-close scrim is
       needed since content isn't otherwise reachable behind the panel. -->
  <div class="sidenav-backdrop" *ngIf="isOver() && sidePanelOpened" (click)="closeSidePanel()"></div>

  <div class="app-inner">
    <ngx-ui-loader [loaderId]="contentViewLoader"></ngx-ui-loader>
    <div class="app-content" [class.app-content--pushed]="sidePanelOpened && !isOver()">
      <app-header></app-header>
      <router-outlet></router-outlet>
    </div>
  </div>
  <app-sign-out-message *ngIf="showSignOutModal"></app-sign-out-message>

  <!-- Demo Purposes Only -->
  <!-- <app-options (messageEvent)="receiveOptions($event)"></app-options> -->
  <!-- /Demo Purposes Only -->
  <div>
    <div (click)="toggleSidePanel()" class="floating-collapse-btn"
      [ngClass]="{ 'floating-collapse-btn-closed': !sidePanelOpened, 'floating-collapse-btn-opened': sidePanelOpened }">
      <vng-icon name="arrow_back_ios" [outline]="false" color="inherit" *ngIf="sidePanelOpened"></vng-icon>
      <vng-icon name="arrow_forward_ios" [outline]="false" color="inherit" *ngIf="!sidePanelOpened"></vng-icon>
    </div>
  </div>
</div>